const platform = require('platform');

import React, { Component } from 'react';

class DeviceController extends Component {

  constructor(props) {
    super(props);
    this.state = this.props;

    // when mobile also render desktop
    // if (this.props.location.split('/')[1] === 'm') {
    //   this.props.updateRouteByDevice(this.props.location.substr(2))
    // }

    // normal
    // if (platform.os.family !== 'iOS' && platform.os.family !== 'Android' && this.props.location.split('/')[1] === 'm') {
    //   this.props.updateRouteByDevice(this.props.location.substr(2))
    // }

    // if ((platform.os.family === 'iOS' || platform.os.family === 'Android') && this.props.location.split('/')[1] !== 'm') {
    //   this.props.updateRouteByDevice('/m' + this.props.location)
    // }

    console.log(this.props.location)
    let pathArr = this.props.location.split('/');
    console.log(platform.os.family);
    console.log(pathArr);
    console.log(pathArr[2]);

    if (platform.os.family !== 'iOS' && platform.os.family !== 'Android' && pathArr[2] === 'm') {
      pathArr.splice(2, 1);
      console.log(pathArr);
      this.props.updateRouteByDevice(pathArr.join('/'))
    }

    if ((platform.os.family === 'iOS' || platform.os.family === 'Android') && pathArr[2] !== 'm') {
      pathArr.splice(2, 0, 'm');
      console.log(pathArr);
      this.props.updateRouteByDevice(pathArr.join('/'))
    }
  }

  componentDidMount() {

  }

  componentWillUpdate(){

  }

  changePositioning() {

  }

  render() {
    return <div></div>
  }
}


export default DeviceController;




// WEBPACK FOOTER //
// ./src/util/DeviceController.js